import moment from "moment"
import { padStart, reduce, get } from "lodash"
import { observable, computed, action } from "mobx"
import { firebase } from "../app/constants"
import { billingStore } from "../app/stores"

class TeamStore {
  @observable initialized = false
  @observable team = null
  @observable users = observable.map()
  @observable banList = null
  @observable analytics = null
  @observable showArchived = false

  @computed
  get teamId() {
    return this.team ? this.team.key : null
  }
  @computed
  get teamIcon() {
    return get(this.team, "slackData.team.icon.image_88")
  }
  @computed
  get teamName() {
    return get(this.team, "slackData.team.name", "Team")
  }
  @computed
  get teamEmail() {
    return get(this.team, "stripeData.email", "")
  }
  @computed
  get teamDomain() {
    return get(this.team, "slackData.team.domain")
  }
  @computed
  get sessionsToday() {
    if (!this.analytics) return 0
    return this.analytics[moment().date()] || 0
  }
  @computed
  get sessionsThisMonth() {
    if (!this.analytics) return 0
    return reduce(this.analytics, (sum, count) => sum + count, 0)
  }
  @computed
  get activeChannels() {
    if (!this.team || !this.team.channels) return []
    return Object.values(this.team.channels).filter(channel => {
      return (
        !this.team.archivedChannels ||
        !this.team.archivedChannels[channel.slackChannelId]
      )
    })
  }
  @computed
  get archivedChannels() {
    if (!this.team || !this.team.channels) return []
    return Object.values(this.team.channels).filter(channel => {
      return (
        this.team.archivedChannels &&
        this.team.archivedChannels[channel.slackChannelId]
      )
    })
  }
  @computed
  get archivedCount() {
    return this.archivedChannels.length
  }
  @computed
  get canAddChannel() {
    if (billingStore.hasMultiChannelAccess) return true
    return this.activeChannels.length < 1
  }

  @action.bound
  listenToTeam(teamId) {
    if (this.teamId === teamId) return
    firebase
      .database()
      .ref(`slackTeam/${teamId}`)
      .on(
        "value",
        action(snap => {
          const team = snap.val()
          if (team) {
            this.team = team
            this.team.key = snap.key
            // update billing store
            billingStore.setSubscription(team.subscription)
            billingStore.setStripeData(team.stripeData)
            // initialize listeners
            if (!this.initialized) {
              this.initialized = true
              this.listenToUsers()
              this.listenToBanList()
              this.listenToAnalytics()
            }
            // update sessionData
            if (window.Smallchat && window.Smallchat.set) {
              window.Smallchat.set("team", this.teamName)
              window.Smallchat.set("domain", this.teamDomain)
            }
          }
        })
      )
  }

  @action.bound
  listenToUsers() {
    Object.values(this.team.scUsers).forEach(user => {
      firebase
        .database()
        .ref(`slackUserData/${user.slackUserId}`)
        .once(
          "value",
          action(snap => {
            const userData = snap.val()
            const userKey = userData.user.id
            this.users.set(userKey, userData)
          })
        )
    })
  }

  @action.bound
  listenToAnalytics() {
    const year = moment().year()
    const month = padStart(moment().month(), 2, 0)
    firebase
      .database()
      .ref(`scSessionAnalytics/${this.teamId}`)
      .child(`${month}${year}`)
      .on(
        "value",
        action(snap => {
          const analytics = snap.val()
          this.analytics = reduce(
            analytics,
            (counts, analytic) => {
              const date = moment(analytic.time).date()
              counts[date] ? (counts[date] += 1) : (counts[date] = 1)
              return counts
            },
            {}
          )
        })
      )
  }

  @action.bound
  listenToBanList() {
    firebase
      .database()
      .ref(`slackTeam/${this.teamId}/ipBanList`)
      .on(
        "value",
        action(snap => {
          this.banList = snap.val()
        })
      )
  }

  @action.bound
  changeBan(ip, banned) {
    const key = ip.replace(/\./g, "")
    firebase
      .database()
      .ref(`slackTeam/${this.teamId}/ipBanList/${key}`)
      .child("banned")
      .set(banned)
  }

  @action.bound
  toggleArchivedVisibility() {
    this.showArchived = !this.showArchived
  }
}

const teamStore = new TeamStore()

export default teamStore



// WEBPACK FOOTER //
// ./src/dashboard/team-store.js